export const DEFAULT_DATA_HOOK_INTERVAL = 5000;

export const AUTO_FETCH = true;
